import { render, staticRenderFns } from "./selectShipment.vue?vue&type=template&id=20b51f8a"
import script from "./selectShipment.vue?vue&type=script&lang=js"
export * from "./selectShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports